import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: ":chatId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "messaging-search-detailed-chat" */ "./components"
        ),
        import(
          /* webpackChunkName: "messaging-search-detailed-chat" */ "MessagingV2/modules/MessagingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducerImport = importedModule1;
        injectReducer(store, {
          key: reducerImport.NAME,
          reducer: reducerImport.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
